import mapTravelMobileAddon, { isTravelAddon, isTravelBalance, isExpiredTravelBalance } from '@/helpers/travel-mobile-addon'


const getters = {

    travel_product: (state, getters) =>
        getters.is_travel_mobile
            ? getters.customer_mobiles.find(mobile => mobile.UUID === getters.customer_current_product_uuid) || null
            : null,


    is_travel_pre_activated: (state, getters) => {
        const product = getters.travel_product
        return Boolean(product) && (product.Status < 4 || !product.BillingReference)
    },

    is_travel_activated: (state, getters) => {
        const product = getters.travel_product
        return Boolean(product) && product.Status === 4
    },

    is_travel_not_active: (state, getters) => {
        const product = getters.travel_product
        return Boolean(product) && product.Status > 4
    },


    current_travel_addons: (state, getters) =>
        (getters.customer_current_prepayed_addons || []).filter(isTravelAddon),


    travel_plan_cards: (state, getters) => getters.current_travel_addons.map(mapTravelMobileAddon),

    has_travel_plan_cards: (state, getters) => getters.travel_plan_cards.length > 0,


    travel_balances: (state, getters) =>
        (getters.customer_current_product_usage_products || []).filter(isTravelBalance),

    live_travel_balances: (state, getters) =>
        getters.travel_balances.filter(product => !isExpiredTravelBalance(product)),

    // Balances have arrived and every travel add-on on them has expired
    has_only_expired_travel_balances: (state, getters) =>
        getters.travel_balances.length > 0 && getters.live_travel_balances.length === 0,
}

export default {
    getters,
}
